module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 8);
}({
  0: function _(e, t) {
    e.exports = require("react");
  },
  1: function _(e, t) {
    e.exports = require("prop-types");
  },
  8: function _(e, t, n) {
    "use strict";

    n.r(t);

    var r = n(0),
        o = n.n(r),
        u = function u(e) {
      return document.querySelector("#".concat(e)) || null;
    },
        i = n(1),
        c = n.n(i);

    function a(e) {
      return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function f(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function l(e, t) {
      return !t || "object" !== a(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function p(e) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var y = function (e) {
      function t(e) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = l(this, p(t).call(this, e))).wrapper = o.a.createRef(), n;
      }

      var n, r, u;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (r = [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
              t = e.injectedComponent,
              n = e.id;
          t ? (t.parentElement.removeChild(t), t.style.display = "block", this.wrapper.current.appendChild(t)) : console.error("Injected Element [#".concat(n, "] was not found in the document"));
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value() {
          return !1;
        }
      }, {
        key: "render",
        value: function value() {
          return o.a.createElement("div", {
            ref: this.wrapper
          });
        }
      }]) && f(n.prototype, r), u && f(n, u), t;
    }(r.Component);

    y.propTypes = {
      injectedComponent: c.a.any.isRequired,
      id: c.a.string.isRequired
    };
    var d = y;

    function b(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var n = [],
            r = !0,
            o = !1,
            u = void 0;

        try {
          for (var i, c = e[Symbol.iterator](); !(r = (i = c.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, u = e;
        } finally {
          try {
            r || null == c.return || c.return();
          } finally {
            if (o) throw u;
          }
        }

        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var m = function m(e) {
      var t = u(e),
          n = b(Object(r.useState)(null), 2),
          i = n[0],
          c = n[1];
      return Object(r.useEffect)(function () {
        c(o.a.createElement(d, {
          injectedComponent: t,
          id: e
        }));
      }, [t]), i;
    };

    t.default = m;
  }
});